import React, { useEffect } from 'react';
import styled from 'styled-components';
import { ListGroup } from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
import { ChevronLeft, ChevronRight } from 'react-feather';

import { CardVaga } from 'components';
import { useSelector, useDispatch } from 'react-redux';
import { vagasActions } from 'store/ducks';
import _ from 'lodash';
import Fade from 'react-bootstrap/Fade';
import VagaSkeleton from './VagaSkeleton';
import './styles.scss';

const StyledList = styled(ListGroup)`
  display: flex;
  justify-content: center;
`;

const ListItem = styled(ListGroup.Item)`
  border: none;
  background: transparent;
`;

const ListaVagas = () => {
  const dispatch = useDispatch();
  const vagas = useSelector(state => state.vagas.data);
  const count = useSelector(state => state.vagas.count);

  const vagasLoader = useSelector(state => state.app.vagas.loading);

  useEffect(() => {
    dispatch(vagasActions.listarVagas());
  }, []);

  const handleChange = ({ selected }) => {
    dispatch(vagasActions.listarVagas(selected + 1));
  };

  return (
    <StyledList>
      <Fade in appear timeout={3000}>
        {!vagasLoader ? (
          <>
            {_.isEmpty(vagas) && !vagasLoader ? (
              <div>
                <p className="text-center">Nenhuma vaga encontrada</p>
              </div>
            ) : (
              vagas.map(vaga => (
                <ListItem key={vaga.id}>
                  <CardVaga vaga={vaga} />
                </ListItem>
              ))
            )}
          </>
        ) : (
          <>
            <VagaSkeleton />
            <VagaSkeleton />
            <VagaSkeleton />
          </>
        )}
      </Fade>
      <div className="d-flex justify-content-center p-4">
        <ReactPaginate
          containerClassName="pagination"
          pageClassName="list-item"
          activeClassName="active"
          activeLinkClassName="active-item"
          pageLinkClassName="item"
          previousLabel={<ChevronLeft />}
          nextLabel={<ChevronRight />}
          breakLabel="..."
          pageCount={count / 15}
          marginPagesDisplayed={5}
          pageRangeDisplayed={5}
          onPageChange={handleChange}
        />
      </div>
    </StyledList>
  );
};

export default ListaVagas;
